module.exports = __webpack_public_path__ + "static/media/Tire.fae4fa33.svg";